import { gql } from '@src/__generated__';

export const GET_COMPARISON = gql(`
  query GetComparison($destinations: [NutsDestination!]!, $tripProfileId: ID!) {
    getComparison(destinations: $destinations, tripProfileId: $tripProfileId) {
      comparison {
        destination
        notableFeatures
        infrastructure
        safety
        transportation
        weather
        crowds
      }
    }
  }
`);
